module.exports = __webpack_public_path__ + "img/logo.92e3f2cd.png";